import { withInstall } from '@ll-plus/utils'

import Iframe from './src/iframe.vue'

export const LlIframe = withInstall(Iframe)
export default LlIframe
export * from './src/iframe'

declare module 'vue' {
  export interface GlobalComponents {
    LlIframe: typeof Iframe
  }
}
